export const kellyPlanId = "BQTTRF8";
